document.documentElement.classList.add('page--mw2');

(function(){
  document.documentElement.classList.add('page--mw2');
  var m=["stycznia","lutego","marca","kwietnia","maja","czerwca","lipca","sierpnia","września","października","listopada","grudnia"];
  var dni=["niedziela","poniedziałek","wtorek","środa","czwartek","piątek","sobota"];
  var d=new Date();
  var ds = d.getDate()+" "+m[d.getMonth()]+" "+d.getFullYear();
  var td=document.getElementById('mw2TopDate');
  if(td) td.textContent = dni[d.getDay()]+", "+ds;

  var st=document.getElementById('mw2Sticky'), pg=document.getElementById('mw2Prog'),
      offer=document.getElementById('oferta'), offerVisible=false, ticking=false;
  if('IntersectionObserver' in window && offer){
    new IntersectionObserver(function(es){ offerVisible = es[0].isIntersecting; apply(); }, {threshold:.1}).observe(offer);
  }
  function apply(){
    var h=document.documentElement;
    var maxScroll=h.scrollHeight-h.clientHeight;
    if(st) st.classList.toggle('show', maxScroll>0 && h.scrollTop/maxScroll>=0.30 && !offerVisible);
    if(pg){
      var max=h.scrollHeight-h.clientHeight;
      pg.style.width = (max>0 ? Math.min(100, h.scrollTop/max*100) : 0) + '%';
    }
  }
  function onScroll(){
    if(ticking) return; ticking=true;
    requestAnimationFrame(function(){ apply(); ticking=false; });
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  var sf=document.getElementById('mw2Search');
  if(sf) sf.addEventListener('submit', function(e){
    e.preventDefault();
    var t=document.querySelector('.mw2 .relgrid');
    if(t) t.scrollIntoView({behavior:'smooth', block:'center'});
  });
  var cp=document.getElementById('mw2Copy');
  if(cp) cp.addEventListener('click', function(){
    try{ navigator.clipboard.writeText(location.href.split('?')[0]); cp.style.borderColor='#19d36f'; }catch(e){}
  });

  /* TTS — progressive: bar widoczny tylko gdy speechSynthesis ma polski glos */
  try{
    var synth = window.speechSynthesis;
    if(synth){
      var ttsBox=document.getElementById('mw2Tts'), btn=document.getElementById('mw2TtsBtn'),
          ip=document.getElementById('mw2TtsPlay'), ipa=document.getElementById('mw2TtsPause'),
          bar=document.getElementById('mw2TtsBar'), speaking=false, idx=0, inited=false;
      function plVoice(){
        var vs=synth.getVoices();
        for(var i=0;i<vs.length;i++){ if(/^pl/i.test(vs[i].lang)) return vs[i]; }
        return null;
      }
      function initTts(){
        if(inited) return;
        var v=plVoice();
        if(!v || !ttsBox) return;
        inited=true;
        ttsBox.classList.add('on');
        var ps=document.querySelectorAll('.mw2 .main .lead, .mw2 .main > p, .mw2 .main h2, .mw2 .main blockquote p');
        var texts=[];
        ps.forEach(function(p){ var t=p.textContent.trim(); if(t) texts.push(t); });
        btn.addEventListener('click', function(){
          if(speaking){ synth.cancel(); speaking=false; ip.style.display='block'; ipa.style.display='none'; return; }
          speaking=true; ip.style.display='none'; ipa.style.display='block'; idx=0;
          function next(){
            if(!speaking || idx>=texts.length){ speaking=false; ip.style.display='block'; ipa.style.display='none'; if(bar)bar.style.width='0'; return; }
            var u=new SpeechSynthesisUtterance(texts[idx]);
            u.voice=v; u.lang='pl-PL'; u.rate=1.02;
            u.onend=function(){ idx++; if(bar)bar.style.width=(idx/texts.length*100)+'%'; next(); };
            synth.speak(u);
          }
          next();
        });
      }
      if(synth.getVoices().length) initTts();
      else synth.onvoiceschanged=initTts;
    }
  }catch(e){}
})();

(() => {
  const pdp = 'https://noom.pl/products/masazer-kolan-noomkneepro';
  const keep = /^(utm_.+|ad_id|adset_id|campaign_id|fbclid|gclid|dclid|ttclid|msclkid|wbraid|gbraid|clickid|klikid|sccid|li_fat_id)$/i;
  const incoming = new URLSearchParams(location.search);
  document.querySelectorAll(`a[href="${pdp}"]`).forEach(a => {
    const url = new URL(pdp);
    incoming.forEach((value,key) => {if(keep.test(key))url.searchParams.set(key,value);});
    a.href=url.href;
  });
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const videos=[...document.querySelectorAll('video')];
  const visible=new Set();
  const sync=v=>{
    v.muted=true;
    v.controls=reduced.matches;
    if(reduced.matches || document.hidden || !visible.has(v))v.pause();
    else v.play().catch(()=>{v.controls=true;});
  };
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{
    if(e.isIntersecting)visible.add(e.target);else visible.delete(e.target);
    sync(e.target);
  }),{threshold:0.1});
  videos.forEach(v=>{v.muted=true;v.loop=true;v.playsInline=true;observer.observe(v);});
  document.addEventListener('visibilitychange',()=>videos.forEach(sync));
  reduced.addEventListener('change',()=>videos.forEach(sync));
})();


(function(){var t=document.getElementById('toc-produkt'),r=document.documentElement;if(!t)return;
function f(){if(t.getBoundingClientRect().top<innerHeight*0.9){r.classList.add('mw2-po-prezentacji');removeEventListener('scroll',f)}}
addEventListener('scroll',f,{passive:true});f();})();
